// extracted by mini-css-extract-plugin
export default {"quantityMessage":"quantityMessage__12d8U"};
    if(module.hot) {
      // 1790586310111
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  